import { useEffect } from 'react';
import {
  offReceiveUpdateChatStatDetailEvent,
  onReceiveUpdateChatStatDetailEvent,
  useCountChatSessionQuery
} from 'services';
import { CountChatSessionDto } from 'types';

export function useCountChatSession(params: CountChatSessionDto) {
  const { data, error, isLoading, refetch } = useCountChatSessionQuery(params);

  useEffect(() => {
    onReceiveUpdateChatStatDetailEvent((data) => {
      refetch();
    });
    return () => {
      offReceiveUpdateChatStatDetailEvent();
    };
  }, []);

  return {
    data: data?.data,
    error,
    isLoading
  };
}
